<template>
  <div>
    <table class="table mt-0 table-sm table-hover">
      <thead>
      <tr>
        <th></th>
        <th>ID</th>
        <th>препарат</th>
        <th>егк</th>
        <th>проекты</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(d,i) in drugs">
        <td>{{ i + 1 }}</td>
        <td>{{ d.drug_id }}</td>
        <td>{{ d.title }}</td>
        <td>{{ d.egk_id }}</td>
        <td><span v-for="(p,i) in d.disabled_projects">{{ (i !== 0 ? ', ' : '') + $AllProjects[p].title}}</span></td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  props: ['drugs'],
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce(
        (acc, p) => {
          acc[p.id] = {...p}
          return acc
        },
        {}
      )
    },
  },
}

</script>
